import axios from "axios";

const resource = "api/auth";

export default {
  ResetPassword: data => {
    return axios.post(`${resource}/reset-password`, data);
  }
};
